import React, {useEffect, useState} from 'react';

import {useNavigate, useParams} from "react-router-dom";

import CanvasJSChart from "./ReactCanvasJSChart";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import { getPanelHeader } from "./DashboardPanelFunctions";
import { getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import { getAdminSectionQuestionRAGStats, } from "root/DataFunctions/ChartFns";

import { RagStatusValues } from "root/ReactHookForm/ui/ReactRAGStatus";

const DashboardPanelAdminQuestionRAGBarStats = ( { panelStyle='panel-default', title='Title', id }) =>
{
	const [ data, setData ] = useState ( { loading: true, data: [], dataPoints: []})

	const navigate = useNavigate() ;

	let { section_number } = useParams();

	useEffect(() =>
	{
		getServerData() ;
	}, []);

	const toolTipContent = (e) =>
	{
		const question_text = e.entries[0].dataPoint.question_text ;
		const bar_index = e.entries[0].index;

		// Work out which colour we are hovering over
		const color = e.entries[0].dataSeries._index ;

		const stacks = e.entries[0].dataSeries.chart.data ;

		const unassessedCount = stacks[0].dataPoints[bar_index].y ;
		const greenCount = stacks[1].dataPoints[bar_index].y ;
		const amberCount = stacks[2].dataPoints[bar_index].y ;
		const redCount = stacks[3].dataPoints[bar_index].y ;

		console.log ( "Color " + color ) ;

		let labels = "<div style='max-width: 300px;' class='wordwrap'><p style=\"color: " + 'blue' + "\">" + question_text + "</p>" +
			"<span style='color: #e63f22;'><span>Red : </span>" + redCount + "</span><br>" +
			"<span style='color: #FFC000;'><span>Amber : </span>" + amberCount + "</span><br>" +
			"<span style='color: #92D050;'><span>Green : </span>" + greenCount + "</span><br>" +
			"<span style='color: #868686;'><span>Unassessed : </span>" + unassessedCount + "</span><br>" +
			"</div>"  ;

		return labels ;
	}

	const onRowClickRed = ( e ) =>
	{
		const url = "/dashboard/rag_report/" + section_number + '/' + e.dataPoint.table_question_id + '?status=1';

		navigate(url);
	}

	const onRowClickAmber = ( e ) =>
	{
		const url = "/dashboard/rag_report/" + section_number + '/' + e.dataPoint.table_question_id + '?status=2';

		navigate(url);
	}

	const composeLabel = ( record ) =>
	{
		const hasRef = record.section_ref !== null && record.question_ref !== null ;

		const refText = hasRef ? record.section_ref + '.' + record.question_ref  : 'Q' + record.table_question_id ;

		return refText ;
	}

	const statusData = ( status, reportData ) =>
	{
		const red = reportData.map ((row) =>
		{
			const scores = row.scores ;

			const count = scores.reduce((cur, rec) =>
			{
				return +(rec.status) === status ? +(rec.count) : cur ;
			}, 0);

			const label = composeLabel ( row ) ;

			return { label: label,
				table_question_id: row.table_question_id,
				question_text: row.summary_text === null ? row.question_text : row.summary_text,
				y: count,
			}
		}) ;

		return red ;
	}

	const getServerData = () =>
	{
		getAdminSectionQuestionRAGStats('current', section_number, (response) =>
		{
			const reportData = getDataFromResponse(response);

			const scores = reportData[0].scores ;

			const subCount = scores.reduce((cur1, rec1) =>
			{
				const s = +(rec1.count) ;

				cur1 += s ;

				return cur1 ;
			}, 0);

			const amber = statusData ( RagStatusValues.AMBER, reportData ) ;
			const red = statusData ( RagStatusValues.RED, reportData ) ;
			const green = statusData ( RagStatusValues.GREEN, reportData ) ;
			const unscored = statusData ( RagStatusValues.UNSET, reportData ) ;

			const graphData = [
				{
					type: "stackedColumn",
					name: "Not Scored",
					showInLegend: false,
					color: "#f0f1f0",
					dataPoints: unscored,
				},
				{
					type: "stackedColumn",
					name: "Green",
					showInLegend: false,
					color: "#92D050",
					dataPoints: green,
				},
				{
					type: "stackedColumn",
					name: "Amber",
					showInLegend: false,
					color: "#FFC000",
					click: onRowClickAmber,
					cursor: 'pointer',
					dataPoints: amber
				},
				{
					type: "stackedColumn",
					name: "Red",
					showInLegend: false,
					color: "#e63f22",
					click: onRowClickRed,
					cursor: 'pointer',
					dataPoints: red,
				},
			] ;

			setData({loading: false, dataPoints: graphData, data: reportData, interval: subCount / 10}) ;
		});

	}

	const formPanel = () =>
	{
		const options = {
			animationEnabled: true,
			height: 400,
			backgroundColor: "#FAFBFD",

			title: {
				text: "",
				fontColor: '#333',
				fontSize: 18,
				fontWeight: 'lighter',
				fontFamily: 'tahoma',
				padding: 20
			},
			axisX:{
				title:'',
				titleFontColor: '#333',
				titleFontSize: 14,
				//titleFontWeight: 'lighter',
				titleFontFamily: 'tahoma',
				margin: 50,
				tickLength: 0
			},
			axisY: {
				title: "Questions",
				interlacedColor: "white",
				interval: data.interval ,
				titleFontSize: 14,
				gridColor: "white",
				titleFontFamily: 'tahoma',
				tickLength: 0
			},
			legend: {
				verticalAlign: "center",
				horizontalAlign: "right",
				reversed: true,
				cursor: "pointer",
				fontSize: 16,
			},
			toolTip: {
				shared: false,
				content: toolTipContent,
				reversed: true
			},

			data: data.dataPoints
		};

		return (
			<div className={'panel ' + panelStyle}>
				{ getPanelHeader({ title: title })}
				<div className='panel-body'>
					<CanvasJSChart id='chartAdminRag' options={options} uniqueId={'canvas'+ id}/>
				</div>
			</div>
		)
	}

	if ( data.loading === true )
	{
		return <SpinnerDiv/>
	}
	else
	{
		return formPanel() ;
	}

};

export default DashboardPanelAdminQuestionRAGBarStats;

